import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
};

export const LinkToSignupPage = ({ children, onClick }: Props) => {
  return (
    <Link to={'/signup' + location.search} id="signup" className="primary-action" onClick={onClick}>
      {children}
    </Link>
  );
};
